import "styles/termsConditions.less";

import React from "react";

import { Col, Typography } from "antd";

import { UK_ROUTES } from "../../../constants/routes";
import Layout from "../../basic/Layout";
import Navigation from "../../basic/Navigation/Navigation";

const TermsConditions: React.FC = () => {
    return (
        <Layout>
            <Navigation items={[{
                title: "Home",
                url: UK_ROUTES.home,
            }, {
                title: "Terms and Conditions",
                url: UK_ROUTES.tcs,
            }]} />
            <Col className="terms-conditions__content">
                <Typography className="terms-conditions__page_title">
                    Terms and Conditions
                </Typography>

                <Typography className="terms-conditions__text">
                    When you instruct us to provide tax return and/or tax refund services,
                    you are agreeing to the matters under the following headings in these terms:
                </Typography>
                <ul className="terms-conditions__text">
                    <li>The meaning of certain words</li>
                    <li>Where to find information about us and our services</li>
                    <li>We don’t give business customers all the same rights as consumers</li>
                    <li>If you are a business customer this is our entire agreement with you</li>
                    <li>We only accept your instructions when we’ve checked them</li>
                    <li>What we will do for you</li>
                    <li>Our obligations to you</li>
                    <li>Your obligations to us</li>
                    <li>Price & Services</li>
                    <li>Data Protection and Money Laundering</li>
                    <li>Nobody else has any rights under our contract with you</li>
                    <li>If you need to complain</li>
                    <li>If you are consumer you have a right to change your mind</li>
                    <li>We can end our contract with you</li>
                    <li>Changes we can make if we give you notice and an option to terminate</li>
                    <li>You can go to court.</li>
                </ul>
                <Typography className="terms-conditions__text">
                    By clicking “Accept”, you confirm that you accept these terms of use and that you agree to comply
                    with them.
                    We recommend that you print a copy of these terms for future reference.
                    If you have any queries about what these terms mean, please contact us.
                </Typography>
                <Typography className="terms-conditions__title">
                    1. Meaning of Certain Words
                </Typography>
                <Typography className="terms-conditions__text">
                    In these terms:
                    We use the words “TaxZap”, “we”, “us” and “our” when referring to TaxZap, a trading name of TaxZap
                    UK Limited.
                    We’re a company incorporated in England and Wales (Company number:14911531).
                    Our registered office is 90 Sedgwick Street, Cambridge, CB1 3AL, UK.
                    When we use the words “you” and “your” we are referring to the person to whom we are providing our
                    services.
                </Typography>
                <Typography className="terms-conditions__title">
                    2. Where To Find Information About Us and Our Services
                </Typography>
                <Typography className="terms-conditions__text">
                    You can find everything you need to know about us, TaxZap UK Limited, our services,
                    and our fees and how you pay them on our website before you ask us to provide our services –
                    please refer to our Key Terms section at the beginning of this document. We also confirm the fees
                    that we will charge,
                    alongside your expected refund (if applicable), when we send you your Tax Refund claim or Tax Return
                    for approval, by email.
                </Typography>
                <Typography className="terms-conditions__title">
                    3. We Don’t Give Business Customers All the Same Rights As Consumers
                </Typography>
                <Typography className="terms-conditions__text">
                    For example, business customers can’t cancel their orders, they have different rights where there is
                    a problem with a service and we don’t compensate them in the same way for losses caused by us or our
                    services. Where a term applies just to businesses or just to consumers, this is clearly stated. You
                    are a business customer if you are buying services wholly or mainly for use in connection with your
                    trade, business, craft or profession, even if you are an individual. If you are a consumer, please
                    refer to paragraph 17 which includes important information about your right to change your mind.
                </Typography>
                <Typography className="terms-conditions__title">
                    4. If You Are a Business Customer This Is Our Entire Agreement With You
                </Typography>
                <Typography className="terms-conditions__text">
                    4.1 Where you are a consumer, you may under the Consumer
                    Rights Regulations cancel the Contract if you notify us as
                    set out in clause 2 within 14 days of your receipt of the
                    Submission Confirmation (cooling off period). You cannot
                    cancel the Contract once we have completed the Services,
                    even if the 14 day cooling off period is still running.
                </Typography>
                <Typography className="terms-conditions__text">
                    4.2 To cancel the Contract, you must email us at
                    support@taxzap.ie. If you are emailing us or writing to us,
                    please include details of your submission to help us to
                    identify it. If you send us your cancellation notice by
                    email or by post, then your cancellation is effective from
                    the date you send us the email or post the letter to us. For
                    example, you will have given us notice in time as long as
                    you get your letter into the last post on the last day of
                    the cancellation period or email us before midnight on that
                    day.
                </Typography>
                <Typography className="terms-conditions__text">
                    4.3 If you cancel the Contract before the end of the cooling
                    off period, and where you begin using the Services or any of
                    them before the end of the cooling off period, you hereby
                    acknowledge that you will be liable for all charges incurred
                    up to the date of cancellation.
                </Typography>
                <Typography className="terms-conditions__text">
                    4.4 Please note that the giving of notice to the Taxing
                    Authority by you, seeking to cancel the Services is a valid
                    cancellation and will terminate the link on the Taxing
                    Authority record.
                </Typography>
                <Typography className="terms-conditions__title">
                    5. Our Services
                </Typography>
                <Typography className="terms-conditions__text">
                    5.1 Descriptions and illustrations: Any descriptions or
                    illustrations on our Site are published for the sole purpose
                    of giving an approximate idea of the Services described in
                    them. They will not form part of the Contract or have any
                    contractual force.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.2 Services Exclusions from Liability: You acknowledge and
                    agree that we shall not be liable to you and or in breach of
                    any obligation of our company under these Terms
                </Typography>
                <Typography className="terms-conditions__text">
                    (a) if you have provided information or an instruction to us
                    which is false, inaccurate, incorrect, insufficient or
                    misleading in any way; or <br/>
                    (b) if you have already received a refund; or <br/>
                    (c) if you have applied for a refund, either directly or
                    through another person, natural or legal; or <br/>
                    (d) you owe money to the Taxing Authority; or <br/>
                    (e) the Taxing Authority has different information on its
                    system than that provided by you to us; or <br/>
                    (f) the Taxing Authority information leads to a decision
                    that you are not due a refund. Where there is a possible
                    case for appeal within the law, such appeal may be taken by
                    us, where the information provided by you to us enables us
                    to do so and where we have agreed the Additional Charges and
                    Vat applicable and they have been paid as provided in these
                    Terms.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.3 Compliance with specification: Subject to our right to
                    amend the specification (see clause 5.4) we will supply the
                    Services to you in accordance with the specification for the
                    Services appearing on our Site at the date of your order in
                    all material respects.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.4 Changes to specification: We reserve the right to amend
                    the specification of the Services if required by any
                    applicable statutory or regulatory requirement or if the
                    amendment will not materially affect the nature or quality
                    of the Services.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.5 Reasonable care and skill: We warrant to you that the
                    Services will be provided using reasonable care and skill,
                    to claim any due rebate of tax due. Please note that we do
                    not issue estimates of rebates due. All rebates are agreed
                    with the Taxing Authority prior to confirmation with you.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.6 Time for performance: We will use all reasonable
                    endeavours to meet any performance dates specified in the
                    Order Confirmation, but any such dates are estimates only
                    and failure to perform the Services by such dates will not
                    give you the right to terminate the Contract.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.7 By using our tax services, you acknowledge and agree that we submit your tax return based
                    on cash accounting principles. We do not cater to traditional accounting methods, and therefore,
                    our services may not be suitable for individuals or businesses utilising such practices for their
                    books. It is your responsibility to ensure compatibility between our tax services and your
                    accounting methods. We shall not be held liable for any discrepancies arising from the mismatch
                    between our submission method and your accounting practices. If you employ traditional accounting
                    methods, it is advised that you refrain from using our services.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.8 By using our tax services, you acknowledge and agree that we submit only full tax year tax
                    returns. We assume that you are submitting for a full tax year and not a part year. It is your
                    responsibility to ensure that the information provided is accurate and pertains to a complete
                    tax year. We shall not be held liable for any discrepancies arising from incomplete or inaccurate
                    information provided for part-year tax returns. If you require assistance with part-year tax
                    returns, please consult a tax professional specialising in such matters.
                </Typography>
                <Typography className="terms-conditions__text">
                    5.9  Automated signature usage: You acknowledge and agree that our submission of the HMRC 64-8 form
                    will be facilitated through the use of an auto-generated signature. This method ensures efficient
                    processing but does not compromise the validity or legality of the submission.
                </Typography>
                <Typography className="terms-conditions__title">
                    6. What We Will Do for You
                </Typography>
                <Typography className="terms-conditions__text">
                    6.1 Tax Refund. If you have instructed us to provide Tax Refund services, we will use the
                    information you have provided in your taxZap account or questionnaire, and through email
                    correspondence with you, to assess and calculate your claim. Once we have calculated your Tax
                    Refund, we complete and submit the appropriate signed forms to claim a tax refund from HMRC.
                </Typography>
                <Typography className="terms-conditions__text">
                    6.2 Tax Return. If HMRC requires you to submit a Tax Return, but a Tax Refund is not available or
                    suitable, TaxZap will calculate how much tax you owe, and complete and submit a signed Tax Return to
                    HMRC. Or where applicable, we will not file a tax return unless a fee is paid when money is owed in
                    taxes.
                </Typography>
                <Typography className="terms-conditions__text">
                    6.3 Handling an enquiry from HMRC. If HMRC launches an enquiry into your Tax Return or Tax Refund
                    claim, we will gather the required information and respond to all queries from HMRC until the
                    enquiry is closed. If we submitted the Tax Return or Tax Refund claim on your behalf, we will handle
                    the enquiry free of charge. If you would like us to defend an HMRC enquiry for a tax return or tax
                    refund claim that we did not prepare or submit, we will charge you an additional amount. Where
                    additional amounts are due, we will only proceed with your agreement on costs.
                </Typography>
                <Typography className="terms-conditions__text">
                    6.4 Tax Code. If you receive a Tax Refund through our service, we’ll contact HMRC to check and
                    update your tax code. We do this because HMRC may automatically change your tax code to include any
                    job expenses for which you have previously claimed. This change assumes that your travel and
                    subsistence costs will continue to stay exactly the same. As you may have a varied workplace and
                    work pattern, we may remove any job expenses that HMRC adds into your tax code as part of our
                    aftercare service. This will prevent you paying too little tax if your circumstances change. If
                    you’d prefer us not to contact HMRC to remove these expenses, please let us know. However, please be
                    aware that if you decide to keep the expenses in your tax code, HMRC will expect you to justify them
                    each year.
                </Typography>

                <Typography className="terms-conditions__title">
                    7. Our Obligations to You
                </Typography>
                <Typography className="terms-conditions__text">
                    7.1 We will provide our services with reasonable care and skill and will accurately process all
                    information you provide to us and take all actions necessary in connection with the provision of our
                    services as quickly as possible.
                </Typography>
                <Typography className="terms-conditions__text">
                    7.2 If HMRC charges a penalty for the late filing of a document or any other default which is caused
                    by us, we will pay the penalty. If it’s not our fault, you will have to pay for it.
                </Typography>
                <Typography className="terms-conditions__text">
                    7.3 We maintain high standards of conduct in our dealings with government departments and others. We
                    may decline to provide a service if we reasonably believe that doing so may breach those standards.
                    We will notify you as soon as we can if we decide not to provide a service.
                </Typography>
                <Typography className="terms-conditions__text">
                    7.4 If you do not provide all the relevant information in our requested timeframes, we will not be
                    liable for the outcome of your Tax Refund claim or Tax Return, or any potential late filing fines.
                    This exemption only applies to the extent that the outcome or fines are a direct result of your
                    failure to provide the required information within the timeframes requested by us.
                </Typography>
                <Typography className="terms-conditions__text">
                    7.5 We will not be liable for any delays in Tax Refunds being paid to you where they have been
                    caused by HMRC’s procedures and security checks.
                </Typography>

                <Typography className="terms-conditions__title">
                    8. Your Obligations to Us
                </Typography>
                <Typography className="terms-conditions__text">
                    8.1 You agree to cooperate with us so that we can provide the services in accordance with our
                    obligations.
                </Typography>
                <Typography className="terms-conditions__text">
                    8.2 You agree to provide the information that we ask for promptly and to make sure that this
                    information is true, accurate, correct and complete, including taking all the necessary steps to get
                    this information from other sources if required.
                </Typography>
                <Typography className="terms-conditions__text">
                    8.3 You will keep accurate records and receipts as required by HMRC to support your Tax Refund claim
                    and retain them for seven years following the tax year to which your Tax Return relates.
                </Typography>
                <Typography className="terms-conditions__text">
                    8.4 You must tell us about all your sources of income and the amounts you receive, including but not
                    limited to, any PAYE, self-employed, pension or rental income and any benefits received in every tax
                    year for which TaxZap is completing a Tax Refund claim or Tax Return. You must also provide honest,
                    accurate and correct details of the money you have spent for the purposes of your work or business,
                    and provide documentary evidence to support your spending when we request it.
                </Typography>
                <Typography className="terms-conditions__text">
                    8.5 You are responsible for approving any Tax Refund claim or Tax Return before we submit it to
                    HMRC. Your approval may be given by either clicking the ‘Accept’ button on our email to you
                    containing your Tax Refund claim or Tax Return, or in writing by email.
                </Typography>
                <Typography className="terms-conditions__text">
                    8.6 You accept that you may have to pay back any money received where the claim was based on
                    incorrect information provided by you. If that happens, you will have no right to claim back any
                    money from TaxZap, including our fee, unless we have made an error too.
                </Typography>

                <Typography className="terms-conditions__title">
                    9. Price & Services
                </Typography>
                <Typography className="terms-conditions__text">
                    9.1 For handling an HMRC enquiry into a claim not submitted by TaxZap, our fees are
                    £85 per hour plus VAT. This is subject to a minimum fee of £85 plus VAT.
                </Typography>
                <Typography className="terms-conditions__text">
                    9.2  Price of our services are subject to change without notice. We reserve the right at any
                    time to modify or discontinue the service without notice at any time. We shall not be liable
                    to you or to any third-party for any modification, price change, suspension or discontinuance of
                    the service. In general, any refunds being made available upon completion of your Self Assessment
                    Tax Return will be issued directly by HMRC.
                </Typography>
                <Typography className="terms-conditions__text">
                    9.3 Where we provide our tax return services, our fees vary depending on the complexity
                    of the tax return. A tax specialist will begin gathering the information needed to
                    complete your Tax Return. At this stage, the complexity will be assessed and we will
                    provide you with a quote. You will need to pay our fees in full before we send your
                    Tax Return to you for approval.
                </Typography>
                <Typography className="terms-conditions__text">
                    9.4 Our tax return services are priced according to the complexity and type of return required:
                </Typography>
                <ul className="terms-conditions__text"><li><strong>Simple Return – £49 </strong></li>
                     For individuals <strong>with employment income only.</strong></ul>
                <ul className="terms-conditions__text"><li><strong>Self-Employed Return – £89 </strong></li>
                    For individuals with <strong>one source of self-employment income, Construction
                    Industry Scheme (CIS) income</strong> , or <strong>rental income.</strong></ul>
                <ul className="terms-conditions__text"><li><strong>Standard Return – £159 </strong></li>
                    For individuals with <strong>multiple income sources.</strong></ul>
                <ul className="terms-conditions__text"><li><strong>Reviewed Return – £220  </strong></li>
                    Includes everything in the Standard Return, <strong>plus a review by an accredited
                    accountant </strong>for added peace of mind.</ul>
                <Typography className="terms-conditions__text">
                A tax specialist will begin gathering your information and confirm the appropriate service tier
                based on your financial situation.  <strong>Full payment is required before we provide your
                completed Tax Return for approval.</strong>
                </Typography>
                <Typography className="terms-conditions__text">
                9.5 The submission fee is non-refundable. It is the responsibility of the user to ensure that all
                information provided in their submission is complete, accurate, and correct.
                </Typography>
                <Typography className="terms-conditions__title">
                    10. Data Protection and Money Laundering
                </Typography>
                <Typography className="terms-conditions__text">
                    10.1 We are registered as a fee payer with the Information Commissioner’s Office.
                </Typography>
                <Typography className="terms-conditions__text">
                    10.2 How we use any personal data you give us is set out in our privacy policy found on our site.
                </Typography>
                <Typography className="terms-conditions__text">
                    10.3 We will securely store all of your physical documents for up to 6 years from the end of the tax year to which they relate in accordance with our retention policy guidelines. After this 6 year period, we will securely destroy your physical documents.
                </Typography>
                <Typography className="terms-conditions__text">
                    10.4 We are registered with HMRC for money laundering supervision (as required under the UK’s
                    Money Laundering Regulations). Our registration number is XAML00000188181. The Money Laundering
                    Regulations require us to check your identity and keep evidence that we have done so. We may
                    carry out electronic searches against your name – for example, against the electoral register -
                    and may ask you to send us photographic ID and two proofs of address so that we can provide the
                    services which fall within the scope of the Money Laundering Regulations.
                </Typography>
                <Typography className="terms-conditions__title">
                    11. Our Responsibility for Losses You Suffer
                </Typography>
                <Typography className="terms-conditions__text">
                    11.1 We don’t compensate you for all losses caused by us or our services.
                </Typography>
                <Typography className="terms-conditions__text">
                    11.2 Our liability to consumers: We are responsible for losses you suffer caused by us breaking this
                    contract unless the loss is:
                    Unexpected. It was not obvious that it would happen and nothing you said to us before we accepted
                    your order meant we should have expected it (so, in the law, the loss was unforeseeable);
                    Caused by a delaying event outside our control, as long as we contact you as soon as reasonably
                    possible to tell you about the delay and do what we can to reduce the delay;
                    Avoidable. Something you (or your agents, employees, officers or advisors) could have avoided by
                    taking reasonable action. For example, we will not be responsible for losses you suffer because you:
                    fail to act on our advice;
                    do not provide us with complete and correct information relevant to the services we are providing,
                    within the timescales we request; or
                    withhold, misrepresent or conceal relevant information; or
                    A business loss. Our liability for any loss you suffer in connection with your trade, business,
                    craft or profession is limited, as described in paragraph 12.3.
                </Typography>
                <Typography className="terms-conditions__text">
                    11.3 Our liability to businesses. If you’re a business customer, then, except in respect of the
                    losses described in paragraph 12.4:
                    we shall not be liable to you, whether in contract, tort (including negligence), breach of statutory
                    duty, or otherwise, for any loss of profit, or any indirect or consequential loss arising under or
                    in connection with any contract between us; and
                    our total liability to you for all other losses arising under or in connection with any contract
                    between us, whether in contract, tort (including negligence), breach of statutory duty, or
                    otherwise, shall be limited to the greater of (i) £250 and (ii) 150% of the total sums paid by you
                    for services under such contract in the 12 month period preceding the date upon which the claim
                    arose.
                </Typography>
                <Typography className="terms-conditions__text">
                    11.4 Nothing in these terms shall limit or exclude our liability for:
                    death or personal injury caused by our negligence, or the negligence of our employees, agents or
                    subcontractors (as applicable);
                    fraud or fraudulent misrepresentation;
                    breach of the terms implied by section 12 of the Sale of Goods Act 1979 or section 2 of the Supply
                    of Goods and Services Act 1982; or
                    any other matter in respect of which it would be unlawful for us to exclude or restrict liability.
                </Typography>

                <Typography className="terms-conditions__title">
                    12. Nobody Else Has Any Rights Under Our Contract With You
                </Typography>
                <Typography className="terms-conditions__text">
                    12.1 The contract under these terms is between you and us. Nobody else can enforce it and neither of
                    us will need to ask anybody else to sign-off on ending or changing it.
                </Typography>
                <Typography className="terms-conditions__text">
                    12.2 The advice and information we provide to you as part of our services is for your sole use and
                    not for any third party to whom you may communicate it, unless we have expressly agreed with you
                    that a specified third party may rely on our work. We accept no responsibility to third parties,
                    including any group company to whom the engagement letter is not addressed, for any advice,
                    information or material produced as part of our work for you which you make available to them.
                </Typography>

                <Typography className="terms-conditions__title">
                    13. You Have Rights if There Is Something Wrong With the Services We Provide
                </Typography>
                <Typography className="terms-conditions__text">
                    13.1 Your rights and remedies if you are a consumer.
                </Typography>
                <Typography className="terms-conditions__text">
                    13.1.1 We honour our legal duty to provide you with services that are as described to you on our
                    website and that meet all the requirements imposed by law.
                </Typography>
                <Typography className="terms-conditions__text">
                    13.1.2 The Consumer Rights Act 2015 says:
                    You can ask us to repeat or fix a service if it's not carried out with reasonable care and skill, or
                    get some money back if we can't fix it.
                    If a price hasn't been agreed upfront, what you're asked to pay must be reasonable.
                    If a time hasn't been agreed upfront, it must be carried out within a reasonable time.
                </Typography>
                <Typography className="terms-conditions__text">
                    13.2 Your legal rights summarised above are subject to certain exceptions. For detailed information
                    please visit the Citizens Advice website. including through our formal and informal Complaints
                    Processes.
                </Typography>
                <Typography className="terms-conditions__text">
                    13.3 Your rights and remedies if you are a business customer. We warrant that we will provide our
                    services with reasonable care and skill. We shall, at our option, repeat or fix a service if it's
                    not carried out with reasonable care and skill or refund the price of the defective service in full
                    and this will be your only remedy for breach of this warranty.
                </Typography>

                <Typography className="terms-conditions__title">
                    14. If You Need to Complain
                </Typography>
                <Typography className="terms-conditions__text">
                    14.1 We are proud of our commitment to quality and our dedication to customers. With thousands of
                    clients every year, occasionally we might not get it right and if you are not happy with any aspect
                    of our performance, we would like to know about it. We want to put it right and prevent it from
                    happening again.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.2 If you are not happy, please let a member of our staff know as soon as possible. In the
                    majority of cases your complaint will be resolved immediately. If you wish to take it further please
                    follow our Complaints Process below.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.3 Complaints Process
                </Typography>
                <Typography className="terms-conditions__text">
                    14.3.1 When you contact us, please let us know that you wish to discuss your issue with our Customer
                    Care Team. We will take your contact details so that we can arrange for the Customer Care Team to
                    call you at a convenient time.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.3.2 A member of the Customer Care Team will speak with the member of staff involved in your
                    matter and collate our notes of the issues and decisions at each stage. The Customer Care Team
                    member will have the relevant information to hand when they call you.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.3.3 The Customer Care Team will then try to deal with the issue by:
                </Typography>
                <Typography className="terms-conditions__text">
                    If not apparent from our notes, establishing what has happened so far, and who has been involved
                    Clarifying the nature of the complaint and what remains unresolved
                    Clarifying what you feel would put things right
                    Agreeing a route to resolution with you.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.3.4 When we have carried out what we said we would to resolve your complaint, we will confirm
                    with you that the issue has now been resolved and the complaint is closed.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.4 If you want to make a formal complaint instead, please write to:
                </Typography>
                <Typography className="terms-conditions__text">
                    The Customer Experience Manager
                    TaxZap UK Limited
                    90 Sedgwick Street, Cambridge, CB1 3AL, UK.
                </Typography>
                <Typography className="terms-conditions__text">
                    14.5 We will acknowledge your written complaint within 20 working days.
                </Typography>

                <Typography className="terms-conditions__title">
                    15. If You Are a Consumer You Have a Right To Change Your Mind
                </Typography>
                <Typography className="terms-conditions__text">
                    15.1 You have 14 days after the date we confirm to you that we have accepted your signed authority
                    form 64-8 to change your mind about it. This is known as a ‘cooling-off’ period. Your right to
                    cancel is subject to some conditions as set out below. If we have already submitted your tax return,
                    we will cancel future claims on your behalf and remove ourselves as your tax agent. But the fees
                    associated with the initial claim will remain the same. The pricing can be found on our website in
                    the pricing section.
                </Typography>
                <Typography className="terms-conditions__text">
                    15.2 To let us know you want to change your mind, contact us via email at support@taxzap.co.uk.
                </Typography>
                <Typography className="terms-conditions__text">
                    15.3 If you bought a service we don't refund you for the time you were receiving it before you told
                    us you'd changed your mind.
                </Typography>
                <Typography className="terms-conditions__text">
                    15.4 If you are due a refund of any fees paid to us, we will refund you as soon as possible and
                    within 14 days of you telling us you've changed your mind. We refund you by bank transfer directly
                    to your preferred bank account. We don't charge a fee for the refund.
                </Typography>

                <Typography className="terms-conditions__title">
                    16. We Can End Our Contract With You
                </Typography>
                <Typography className="terms-conditions__text">
                    We can end our contract with you and claim any compensation due to us if:
                    - we decide that we are unable to continue to act for you. Examples of where this may occur are:
                    if we cannot obtain clear instructions from you;
                    if we believe that we will not be successful in your claim, or;
                    if we, acting reasonably, consider you have given us misleading instructions or information; or
                    - you don't make any payment to us when it's due and you still don't make payment within fourteen
                    days of our reminding you that payment is due.
                </Typography>

                <Typography className="terms-conditions__title">
                    17. Changes We Can Make if We Give You Notice and an Option To Terminate
                </Typography>
                <Typography className="terms-conditions__text">
                    We can alter these terms to reflect changes in law or our business operations or changes in fees,
                    but if we do so we'll notify you and you can then contact us by email at support@taxzap.co.uk to end
                    the contract before the change takes effect and receive a refund for any services you've paid for in
                    advance, but won't receive.
                </Typography>

                <Typography className="terms-conditions__title">
                    18. You Can Go to Court
                </Typography>
                <Typography className="terms-conditions__text">
                    These terms are governed by English law. If you are a consumer then, wherever you live, you can
                    bring claims against us in the English courts and if you live in Wales, Scotland or Northern
                    Ireland, you can also bring claims against us in the courts of the country you live in. If you are a
                    consumer we can claim against you in the courts of the country you live in. If you are a business
                    customer you irrevocably agree to submit all disputes arising out of or in connection with our
                    contract with you to the exclusive jurisdiction of the English courts.
                </Typography>
            </Col></Layout>
    );
};

export default TermsConditions;
